import React, { ForwardedRef } from 'react';
import ReactSelect, {
  components as ReactSelectComponents,
  GroupBase,
  mergeStyles,
  Props,
  SelectInstance,
  SingleValueProps,
} from 'react-select';
import { hofForwardRef } from '../../../utils/types';
import {
  BasicDropdownIndicator,
  EmptyComponent,
  getBorderlessStyles,
} from './SelectUtils';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { useFloatingLayerContext } from '../../FloatingManager';

const StyledSingleValue = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.mainBlue};
`;
/*
 * This component should be used when we have a plain dropdown with static
 * options and there is no fetching logic behind
 */
export default hofForwardRef(
  <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
  >(
    {
      styles,
      components,
      menuPlacement,
      placeholder,
      ...props
    }: Props<Option, IsMulti, Group>,
    ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
  ) => {
    const zIndex = useFloatingLayerContext();

    const selectStyles = mergeStyles(
      getBorderlessStyles<Option, IsMulti, Group>(zIndex),
      styles,
    );

    const SingleValueComponent = <
      Option,
      IsMulti extends boolean = false,
      Group extends GroupBase<Option> = GroupBase<Option>,
    >({
      children,
      ...singleValueProps
    }: SingleValueProps<Option, IsMulti, Group>) => {
      return (
        <ReactSelectComponents.SingleValue {...singleValueProps}>
          <StyledSingleValue>{children}</StyledSingleValue>
        </ReactSelectComponents.SingleValue>
      );
    };
    return (
      <ReactSelect
        {...props}
        ref={ref}
        isSearchable={false}
        menuPlacement={menuPlacement || 'auto'}
        placeholder={placeholder || ''}
        styles={selectStyles}
        noOptionsMessage={() => (props.isLoading ? 'Loading...' : 'No options')}
        components={{
          DropdownIndicator: (props) =>
            BasicDropdownIndicator({ props, color: theme.colors.mainBlue }),
          LoadingIndicator: EmptyComponent,
          IndicatorSeparator: EmptyComponent,
          SingleValue: SingleValueComponent,
          ...components,
        }}
      />
    );
  },
);
